import { ClientEntity, FileEntity, FileTypeName } from 'api/types/entity';
import { parseListDocumentsFiles } from 'modules/client/common/helpers';

export const parseDocumentsFiles = (client: ClientEntity): FileEntity[] =>
  parseListDocumentsFiles([
    {
      files: client.additionalDocumentFiles,
      type: FileTypeName.AdditionalDocument,
      uploadedByAdmin: true,
    },
    {
      files: client.signaturesCardFiles,
      type: FileTypeName.SignaturesCard,
    },
    {
      files: client.documentGroups?.flatMap((v) => v.documents),
      type: FileTypeName.DocumentGroups,
    },
    {
      files: [client.companySignedNoticeOfInvestmentAccountOpeningDocument],
      type: FileTypeName.CompanySignedNoticeOfInvestmentAccountOpening,
    },
    {
      files: [client.companySignedAgreementDocument_Finance],
      type: FileTypeName.CompanySignedAgreement_Finance,
    },
    {
      files: [client.signedApplicationStandardAgreementDocument_Finance],
      type: FileTypeName.SignedApplicationStandardAgreement_Finance,
    },
    {
      files: [client.signedOpenSubAccountOrderDocument_Finance],
      type: FileTypeName.SignedOpenSubAccountOrder_Finance,
    },
    {
      files: [client.invoice?.file],
      type: FileTypeName.Invoice,
    },
    {
      files: client.invoice?.paymentConfirmationFiles,
      type: FileTypeName.InvoicePaymentConfirmation,
    },
  ]);
